var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrollable-content flex-grow-1",style:(_vm.outerStyles)},[_c('div',{staticClass:"header"},[_vm._t("header")],2),_c('div',{staticClass:"body"},[_vm._t("default")],2),_c('div',{staticClass:"footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }